module.exports = __webpack_public_path__ + "static/media/tennis.cde5bfd3.svg";